module.exports = __webpack_public_path__ + "static/media/slide2.41a2fb88.jpg";